import { generateTestId } from "@client-shared";

export const setEditProductModalTestId = (identifier: string): string =>
  generateTestId("EditProductModal", identifier);
